import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import ProjectCard from './ProjectCard';
import useProjectTypeOptions from '../../../hooks/useProjectTypeOptions';
import CommonLoader from '../../../components/common-loader/CommonLoader';
import Icon from '../../../icons/Icon';
import { ICONS } from '../../../icons';

import scss from '../ProjectsList.module.scss';

const ProjectsCards = ({
  onOpenProject,
  onShareProject,
  onEditProject,
  onDeleteProject,
  onDeactivateProject,
  onCollectData,
}) => {
  const { t } = useTranslation('projects');
  const projectTypeOptions = useProjectTypeOptions();
  const projects = useSelector((state) => state.projects.projects);
  const isLoading = useSelector((state) => state.projects.isLoading);

  return (
    <div className={scss.cardsWrapper}>
      {(projects || []).map((project) => (
        <ProjectCard
          key={project.id}
          project={project}
          projectTypeOptions={projectTypeOptions}
          onOpen={onOpenProject}
          onShare={onShareProject}
          onEdit={onEditProject}
          onDelete={onDeleteProject}
          onDeactivate={onDeactivateProject}
          onCollectData={onCollectData}
          disabled={projectTypeOptions.every(({ value }) => value !== project.projectType)}
        />
      ))}

      {!projects.length ? (
        <div className={scss.emptyCards}>
          <Icon icon={ICONS.Unclust} disableCommonStyles currentColor className='empty-table_icon' />
          {t('noData')}
        </div>
      ) : null}

      <CommonLoader isLoading={isLoading} />
    </div>
  );
};

export default ProjectsCards;
